export const trainVipCn = {
    mchrzpt:"贸促会认证平台",
    xztc:"请选择开通会员套餐",
    yinpaihuiyuan:"银钻会员",
    jifengzengzhang:"积分增长速率2倍",
    jinpaihuiyuan:"金钻会员",
    yingfujine:"应付金额",
    xieyi:"支付即同意《中国贸促会中小服务平台-用户协议》",
    kaitongchenggong:"恭喜您，会员开通成功！",
    fanhuiguankan:"返回观看视频",
    qingzailiangfeng:'请在两分钟内完成支付',
    qingshiyong:'请使用',
    weixin:'微信',
    zhifubao:'支付宝',
    zhifubaoruanjian:'支付软件',
    saoyisao:'扫一扫，扫描二维码支付',
    quxiaozf:'取消支付',
    youhuiquan:'优惠卷：',
    qxzyouhui:'请选择活动优惠',
    youhuijinger:'优惠金额：',
    tijiaodd:'提交订单',
    zhifu:'支付',
    jiaoyicg:'订单交易成功',
    daishenghe:'待审核'

}


// WEBPACK FOOTER //
// ./src/lang/home/trainVip/indexCn.js